module.exports = __webpack_public_path__ + "static/media/customers-icon-active.2385b72b.svg";